// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lectures-page {
  min-height: 100svh;
  background: #1f2937;
  color: #f7f4ec;
  overflow-y: auto;
  overflow-x: hidden;
}

.lectures-page__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.8rem 2.75rem 1.5rem;
}

.lectures-page__back {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border: none;
  background: transparent;
  color: #f4f0e9;
  font-size: clamp(1rem, 1.2vw, 1.4rem);
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.lectures-page__back:hover {
  opacity: 0.72;
}

.lectures-page__back svg {
  width: 1.1em;
  height: 1.1em;
}

.lectures-page__brand {
  font-size: clamp(2.4rem, 3vw, 3.6rem);
  font-weight: 800;
  letter-spacing: -0.06em;
  color: #f9fafb;
}

.lectures-page__main {
  max-width: 1180px;
  margin: 0 auto;
  padding: 1rem 2.75rem 5rem;
}

.lectures-page__hero {
  margin-bottom: 2.5rem;
}

.lectures-page__eyebrow {
  font-size: clamp(0.9rem, 1.1vw, 1.1rem);
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9ca3af;
  margin: 0.5rem 0 0;
}

.lectures-page__title {
  margin: 0;
  font-size: clamp(2.4rem, 4.5vw, 4.5rem);
  line-height: 0.95;
  font-weight: 800;
  letter-spacing: -0.06em;
  color: #f7f4ec;
}

.lectures-page__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.5rem;
}

.lectures-page__card {
  border: none;
  background: #e7d3ab;
  border-radius: 1rem;
  overflow: hidden;
  cursor: pointer;
  text-align: left;
  padding: 0;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  display: flex;
  flex-direction: column;
}

.lectures-page__card:hover {
  transform: translateY(-3px);
  box-shadow: 0 0 48px rgba(255, 255, 255, 0.8);
}

.lectures-page__thumbnail {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
}

.lectures-page__thumbnail img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lectures-page__play {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.lectures-page__card:hover .lectures-page__play {
  opacity: 1;
}

.lectures-page__play svg {
  width: 3.5rem;
  height: 3.5rem;
}

.lectures-page__modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: rgba(8, 16, 26, 0.82);
  backdrop-filter: blur(8px);
}

.lectures-page__modal {
  width: min(860px, 100%);
  border-radius: 0.75rem;
  background: #1f2937;
  overflow: hidden;
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.5);
}

.lectures-page__modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.85rem 1.25rem 0.765rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  cursor: grab;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
}

.lectures-page__modal-header.is-dragging { cursor: grabbing; }

.lectures-page__modal-header h3 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: #f7f4ec;
  letter-spacing: -0.02em;
}

.lectures-page__modal-close {
  width: 1.75rem;
  height: 1.75rem;
  border: none;
  padding: 0;
  background: transparent;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.15s;
}

.lectures-page__modal-close:hover {
  color: #e5e7eb;
}

.lectures-page__modal-close svg {
  width: 1.1rem;
  height: 1.1rem;
}

.lectures-page__modal-frame {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
}

.lectures-page__modal-frame iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: none;
}

@media (max-width: 900px) {
  .lectures-page__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .lectures-page__header {
    padding: 1.25rem 1.2rem;
  }

  .lectures-page__main {
    padding: 1rem 1rem 3rem;
  }

  .lectures-page__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/landing/LecturesPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,qDAAqD;EACrD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC;EACjC,kDAAkD;EAClD,YAAY;EACZ,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,2CAA2C,gBAAgB,EAAE;;AAE7D;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gDAAgD;IAChD,SAAS;EACX;AACF","sourcesContent":[".lectures-page {\n  min-height: 100svh;\n  background: #1f2937;\n  color: #f7f4ec;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.lectures-page__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.8rem 2.75rem 1.5rem;\n}\n\n.lectures-page__back {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  border: none;\n  background: transparent;\n  color: #f4f0e9;\n  font-size: clamp(1rem, 1.2vw, 1.4rem);\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n}\n\n.lectures-page__back:hover {\n  opacity: 0.72;\n}\n\n.lectures-page__back svg {\n  width: 1.1em;\n  height: 1.1em;\n}\n\n.lectures-page__brand {\n  font-size: clamp(2.4rem, 3vw, 3.6rem);\n  font-weight: 800;\n  letter-spacing: -0.06em;\n  color: #f9fafb;\n}\n\n.lectures-page__main {\n  max-width: 1180px;\n  margin: 0 auto;\n  padding: 1rem 2.75rem 5rem;\n}\n\n.lectures-page__hero {\n  margin-bottom: 2.5rem;\n}\n\n.lectures-page__eyebrow {\n  font-size: clamp(0.9rem, 1.1vw, 1.1rem);\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #9ca3af;\n  margin: 0.5rem 0 0;\n}\n\n.lectures-page__title {\n  margin: 0;\n  font-size: clamp(2.4rem, 4.5vw, 4.5rem);\n  line-height: 0.95;\n  font-weight: 800;\n  letter-spacing: -0.06em;\n  color: #f7f4ec;\n}\n\n.lectures-page__grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 1.5rem;\n}\n\n.lectures-page__card {\n  border: none;\n  background: #e7d3ab;\n  border-radius: 1rem;\n  overflow: hidden;\n  cursor: pointer;\n  text-align: left;\n  padding: 0;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.lectures-page__card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 0 48px rgba(255, 255, 255, 0.8);\n}\n\n.lectures-page__thumbnail {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n}\n\n.lectures-page__thumbnail img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.lectures-page__play {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.lectures-page__card:hover .lectures-page__play {\n  opacity: 1;\n}\n\n.lectures-page__play svg {\n  width: 3.5rem;\n  height: 3.5rem;\n}\n\n.lectures-page__modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 40;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  background: rgba(8, 16, 26, 0.82);\n  backdrop-filter: blur(8px);\n}\n\n.lectures-page__modal {\n  width: min(860px, 100%);\n  border-radius: 0.75rem;\n  background: #1f2937;\n  overflow: hidden;\n  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.5);\n}\n\n.lectures-page__modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.85rem 1.25rem 0.765rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  cursor: grab;\n  touch-action: none;\n  user-select: none;\n}\n\n.lectures-page__modal-header.is-dragging { cursor: grabbing; }\n\n.lectures-page__modal-header h3 {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #f7f4ec;\n  letter-spacing: -0.02em;\n}\n\n.lectures-page__modal-close {\n  width: 1.75rem;\n  height: 1.75rem;\n  border: none;\n  padding: 0;\n  background: transparent;\n  color: #6b7280;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: color 0.15s;\n}\n\n.lectures-page__modal-close:hover {\n  color: #e5e7eb;\n}\n\n.lectures-page__modal-close svg {\n  width: 1.1rem;\n  height: 1.1rem;\n}\n\n.lectures-page__modal-frame {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n}\n\n.lectures-page__modal-frame iframe {\n  display: block;\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n\n@media (max-width: 900px) {\n  .lectures-page__grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .lectures-page__header {\n    padding: 1.25rem 1.2rem;\n  }\n\n  .lectures-page__main {\n    padding: 1rem 1rem 3rem;\n  }\n\n  .lectures-page__grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
